import angularJsUtilitiesModule from "../angularJsUtilitiesModule";

function abbreviate($filter) {
    "ngInject";
    var skipDivisorName = null;
    var divisorList = ["thousand", "million", "billion"];
    var divisorDict = { "thousand": 1000, "million": 1000000, "billion": 1000000000 };
    var divisorFormatDict = { "thousand": "K+", "million": "M+", "billion": "B+" };
    var divisorFormatWithoutPostfixDict = { "thousand": "K", "million": "M", "billion": "B" };
    var getFormateNumber = function (name, divisor, roundTo) {
        if (skipDivisorName && divisor === skipDivisorName) {
            return $filter('number')(name);
        } else {
            return $filter('number')((name / divisorDict[divisor]).toFixed(0), roundTo) + divisorFormatDict[divisor];
        }
    }
    return function (name, skipDivisor, skipPostfix, roundTo) {
        if (!roundTo) {
            roundTo = 0;
        }

        if (typeof skipDivisor !== "undefined") {
            skipDivisorName = divisorList[skipDivisor];
        }
        
        if (skipPostfix) {
            divisorFormatDict = divisorFormatWithoutPostfixDict;
        }

        if (name < divisorDict["thousand"] * 10) {
            return $filter('number')(name);
        }
        else if (name < divisorDict["million"]) {
            return getFormateNumber(name, "thousand", roundTo);
        }
        else if (name < divisorDict["billion"]) {
            return getFormateNumber(name, "million", roundTo);
        }

        return getFormateNumber(name, "billion", roundTo);
    };
};

angularJsUtilitiesModule.filter("abbreviate", abbreviate);
export default abbreviate;